let nameChangeFormSelection = document.getElementById('name-change-form');
if (Boolean(nameChangeFormSelection)) {
    let nameChangeGlobalElementObject = {};
    nameChangeGlobalElementObject.openDropDown = function(event, setFocusTarget) {
        let moreButton = document.querySelector(".icon-0024_dropdown-more");
        moreButton.classList.toggle("down");
        // Handy vars for various menu dom nodes and IDs.
        var menuId = event.currentTarget.getAttribute('aria-controls');    // this is the ID of the UL. JJ IMPROVING.. call this menuId
        var menu = document.getElementById(menuId);   // this is the UL.  JJ IMPROVING.. call this menu
        var controllerInputID = menu.getAttribute('aria-labelledby'); // needed for proper closure of menu and returning focus to controlling Input.
        var menuContainerId = menu.parentNode.id; // This is the id of the div that contains the UL. Needed for proper menu closure.  wuds-is-open, wuds-is-closed is applied to it.
        var dropdownToOpen = document.getElementById(menuContainerId);   // This is the dom element div that contains the UL. Needed for proper menu closure.  wuds-is-open, wuds-is-closed is applied to it.
      
        // Begin Adding Toggle effect - want to have dropdown such that if user clicks it once it opens and clicking again will close it.
        // but support the case where they may click to open and then use a keypress to get to the menu item
         // see what the event key code was. If it was Key Down or Key Up or other Atria - then do not close the menu. They may have been hitting e.g. Down Arrow to move focus to first item
         var preserveOpenState = false;
         if (event.keyCode) { // if user pressed a key do not close the dropdown. It should be false if user clicked it. Really only want a convenience Toggle off the user clicks it open. Then can click to close.
           preserveOpenState = true;
          //  console.log('***** Leaving menu visible. User probably using Key interactions again on the Input after it is open  ******')
         }
      
        // first check if it's closed. If it is then open it. Also if user has done a key down in the Input.
        if (dropdownToOpen.classList.contains("wuds-is-closed") || preserveOpenState) {   // THIS IS THE TOGGLE ON 
      
          // console.log('***** TOGGLING MENU ON ******')
      
          // see if there is a modal version of the dropdown to open - this is expected for Country Dropdown
          var isMobileModal = document.getElementById(menuContainerId+'-modal');
      
        //   if (breakpointDeviceInUse.value == 'S-size-device' && isMobileModal) { // open the modal which presumes and relies on id being same as that of targetDropdown except with "-modal" appended to it
        //     // console.log('S-size-device breakpoint so open modal');
        //     dropdownToOpen = document.getElementById(menuContainerId+'-modal');
        //   }
      
          // now show the Dropdown (and focus should be on matched element)
          dropdownToOpen.classList.remove("wuds-is-closed"); // remove inactive border color
          dropdownToOpen.classList.add("wuds-is-open");
      
          // See  if need to set focus
          if (setFocusTarget) {
      
            if (setFocusTarget == 'focusOnFirst') {
      
              var popupMenuFirstItem = menu.firstElementChild;
              var popupMenuFirstItemAnchor = popupMenuFirstItem.firstElementChild; // assumes anchor is first child
              popupMenuFirstItemAnchor.focus();
      
            } else if (setFocusTarget == 'focusOnLast') {
      
              var popupMenuLastItem = menu.lastElementChild;
              var popupMenuLastItemAnchor = popupMenuLastItem.firstElementChild; // assumes anchor is first child
              popupMenuLastItemAnchor.focus();
      
            }
          }
      
          // lastly set the aria-expanded="true"    for the Input controller of the menu
          event.currentTarget.setAttribute('aria-expanded',true);
      
          console.log('Inside openPseudoDropdown');
      
        }  else {
      
            console.log('***** TOGGLING MENU OFF ******')
            nameChangeGlobalElementObject.closeDropdown(menuContainerId, controllerInputID);  // close menu, return focus to controlling Input
      
        }
      
    }
      nameChangeGlobalElementObject.justcloseDropdown = function (targetDropdownId, inputToUpdateId) {
        // var dropdown = document.getElementById(targetDropdownId);
        // dropdown.classList.add("wuds-is-closed"); 
        // dropdown.classList.remove("wuds-is-open"); 
        // var cancelIcon = document.getElementsByClassName("wuds-dropdown__search__cancel__icon");
        // if(cancelIcon[0]){ cancelIcon[0].classList.add("d-none");}
        // // lastly set the aria-expanded="false"    for the Input controller of the menu and place focus on the Input
        // var targetInput = document.getElementById(inputToUpdateId);
        // targetInput.setAttribute('aria-expanded',false);
      }
      nameChangeGlobalElementObject.handleKeydownOnInput = function  (event, specialMenu) {
        var keyCodeObj = Object.freeze({
          'TAB': 9,
          'RETURN': 13,
          'ESC': 27,
          'SPACE': 32,
          'PAGEUP': 33,
          'PAGEDOWN': 34,
          'END': 35,
          'HOME': 36,
          'LEFT': 37,
          'UP': 38,
          'RIGHT': 39,
          'DOWN': 40
        });
      
        // SEE IF IT CONTROLS MENU
        // IF SO - call function that opens the menu and places focus at first position
        var popupMenuExists = event.currentTarget.getAttribute('aria-controls');
      
        if (popupMenuExists) {  // IF popup menu exists then determine key pressed and what to do for it
      
          var flag = false;
      
          switch (event.keyCode) { // see if the keycode matches a value of interest in keyCode object of interesting values.
            case keyCodeObj.SPACE:
            case keyCodeObj.RETURN:
            case keyCodeObj.DOWN:   
                 var result = nameChangeGlobalElementObject.openDropDown(event, 'focusOnFirst');
                 flag = true;
              break;
      
            case keyCodeObj.UP:
                 var result = nameChangeGlobalElementObject.openDropDown(event, 'focusOnLast'); 
                 flag = true;
              break;
      
            default:
              break;
          }
      
          if (flag) {
            event.stopPropagation();
            event.preventDefault();
          }
        }
      };
      nameChangeGlobalElementObject.setInputAnswer = function (event) {
        // Relying on knowing markup structure to traverse up to find key parent elements etc. 
        // Update Input with selected value
        var answer = event.currentTarget.querySelector("span").innerHTML; // anchor child is span. Inner html of span we will use as answer.
        var answerKeyValue = event.currentTarget.getAttribute("data-keyvalue");
        var currentListItem = event.currentTarget.parentNode; // Anchor's Parent  is LI. As the user clicks that Lists items Anchor. To drive e.g. previous/next item navigation will need this.
        var menu = currentListItem.parentNode; // LI's parent is  UL 
        var controllerInputId = menu.getAttribute('aria-labelledby'); // ID of Controlling Input is handily in Aria attribute. 
        var menuContainerId = menu.parentNode.getAttribute('id'); // UL's parent is the container div we update to either "wuds-is-closed" or "wuds-is-open".
        var controllerInputElementId = document.getElementById(controllerInputId);
        if(controllerInputElementId){
            controllerInputElementId.value = answer;
            controllerInputElementId.setAttribute("data-value",answer);
            if(answerKeyValue && answerKeyValue != null && answerKeyValue !== ""){
              controllerInputElementId.setAttribute("data-keyvalue",answerKeyValue);
            }
            nameChangeGlobalElementObject.hideValidationMessage(controllerInputElementId);
        }
        // special case though is Mobile where it's a modal so need to close this: country-11-dropdown-modal and not this: country-11-dropdown-modal-dropdown
        // going to strip off "-dropdown" IF 'modal-dropdown' is part of the classname.
        var isMobileModal = menuContainerId.indexOf('modal-dropdown') !== -1;
        if (isMobileModal) {
          menuContainerId = menuContainerId.replace('modal-dropdown','modal');
        }
      
        nameChangeGlobalElementObject.closeDropdown(menuContainerId, controllerInputId);
    }
    nameChangeGlobalElementObject.setFocusToPreviousMenuItem = function (currentListItem) {
        var previousListItem = currentListItem.previousElementSibling;
      
        if (previousListItem) {
          var previousItemAnchor = previousListItem.firstElementChild;
          if (previousItemAnchor) {
            previousItemAnchor.focus();
          }
        } else {
          // must be first item. So find parent UL and go to last child's anchor. 
          var parentUL = currentListItem.parentNode;
          var popupMenuLastItem = parentUL.lastElementChild;
          var popupMenuLastItemAnchor = popupMenuLastItem.firstElementChild; // assumes anchor is first child
          popupMenuLastItemAnchor.focus();
        }
      
      
      }
      
      // helper function for dropdown menu interaction
      // determine next menu item and place focus on it.
      // if there is no next item then place focus on first menu item.
      // @param currentListItem - dom node of current List Item (the LI). The menu construct is assumed to be UL with LI child elements that each have one Anchor child - that has the click and keypress events
      nameChangeGlobalElementObject.setFocusToNextMenuItem = function (currentListItem) {
      
        // user clicked the anchor inside the LI item.  So try to find next LI item and if it exists then it's child anchor and place focus on it
      
        var nextListItem = currentListItem.nextElementSibling;
      
        if (nextListItem) {
          var nextItemAnchor = nextListItem.firstElementChild;
          if (nextItemAnchor) {
            nextItemAnchor.focus();
          }
        } else {
          // must be last item. So find parent UL and go to first child's anchor. 
          var parentUL = currentListItem.parentNode;
          var popupMenuFirstItem = parentUL.firstElementChild;
          var popupMenuFirstItemAnchor = popupMenuFirstItem.firstElementChild; // assumes anchor is first child
          popupMenuFirstItemAnchor.focus();
        }
      
      }
      
      // used for PAGEDOWN keydown
      // @param menu dom node of the UL menu
      nameChangeGlobalElementObject.setFocusToFirstMenuItem = function (menu) {
        var popupMenuFirstItem = menu.firstElementChild;
        var popupMenuFirstItemAnchor = popupMenuFirstItem.firstElementChild; // assumes anchor is first child
        popupMenuFirstItemAnchor.focus();
      }
      
      // used for PAGEDOWN keydown
      // @param menu dom node of the UL menu
      nameChangeGlobalElementObject.setFocusToLastMenuItem = function (menu) {
        var popupMenuLastItem = menu.lastElementChild;
        var popupMenuLastItemAnchor = popupMenuLastItem.firstElementChild; // assumes anchor is first child of the lI
        popupMenuLastItemAnchor.focus();
      }
      
      // this can be implemented as well by setting a global variable for lastFocusedInput for example when the user presses key in the input. The key press handler can set it. Then just reference that to return
      // focus to the controlling input.
      // In this example -we leverage the fact that the Aria Labeled By (aria-labelledby) attribute of the UL list is the ID of the controlling input to place focus on.
      // @param currentListItem dom node of current List Item (the LI).
      nameChangeGlobalElementObject.setFocusToController = function (currentListItem) {
        var controllerInputID = currentListItem.getAttribute('aria-labelledby');
        document.getElementById(controllerInputID).focus();
      }
      nameChangeGlobalElementObject.dropDownSearchKeyUpEventHandler = function (event) {
        var searchInput = event.currentTarget.value;
        var menuId = event.currentTarget.getAttribute('aria-controls');
        var menu = document.getElementById(menuId); 
        var menuListitems = menu.querySelectorAll(".wuds-dropdown__item");
        
        for (let i = 0; i <= menuListitems.length - 1; i++) {
          //console.log(menuListitems[i].getElementsByClassName("dropdown-lists-span"));
          let title = menuListitems[i].getElementsByClassName("dropdown-lists-span")[0].innerText
          //console.log(title);
          if (title.toUpperCase().indexOf(searchInput.toUpperCase()) > -1) {
            menuListitems[i].style.display = "";    
          } else {
            menuListitems[i].style.display = "none";
          }
        }
      }
    nameChangeGlobalElementObject.handleKeydownOnMenuItem = function  (event) {

        var keyCodeObj = Object.freeze({
          'TAB': 9,
          'RETURN': 13,
          'ESC': 27,
          'SPACE': 32,
          'PAGEUP': 33,
          'PAGEDOWN': 34,
          'END': 35,
          'HOME': 36,
          'LEFT': 37,
          'UP': 38,
          'RIGHT': 39,
          'DOWN': 40
        });
      
        var flag = false;
      
        // Handy vars for various menu dom nodes and IDs.
        var currentListItem = event.currentTarget.parentNode; // handy to know what the current list item is. As the user clicks that Lists items Anchor. To drive e.g. previous/next item navigation will need this.
        var currentListItemAnchor = event.currentTarget; // this assumes all our click events are on the anchor tag within list item.
      
        var menu = currentListItem.parentNode; // this is the UL.
        var menuContainerId =menu.parentNode.id; // This is the id of the div that contains the UL. Needed for proper menu closure.  wuds-is-open, wuds-is-closed is applied to it.
        var controllerInputID = menu.getAttribute('aria-labelledby'); // needed for proper closure of menu and returning focus to controlling Input.
      
        switch (event.keyCode) {
          case keyCodeObj.SPACE:
            flag = true;
            break;
      
          case keyCodeObj.RETURN:
            currentListItemAnchor.click(); // trigger the click event - and the listener for that will fire. 
            flag = true;
            break;
      
          case keyCodeObj.ESC:
            nameChangeGlobalElementObject.closeDropdown(menuContainerId, controllerInputID);  // close menu, return focus to controlling Input
            flag = true;
            break;
      
          case keyCodeObj.UP:
            nameChangeGlobalElementObject.setFocusToPreviousMenuItem(currentListItem);  // put focus on previous menu item (the previous LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.DOWN:
            nameChangeGlobalElementObject.setFocusToNextMenuItem(currentListItem);   // put focus on next menu item (the next LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.HOME:
          case keyCodeObj.PAGEUP:
            nameChangeGlobalElementObject.setFocusToFirstMenuItem(menu);   // put focus on first menu item (the next LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.END:
          case keyCodeObj.PAGEDOWN:
            nameChangeGlobalElementObject.setFocusToLastMenuItem(menu);   // put focus on last menu item (the next LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.TAB:
            nameChangeGlobalElementObject.closeDropdown(menuContainerId, controllerInputID);  // close menu, return focus to controlling Input
            // this.popupMenu.setFocusToController();
            // this.popupMenu.close(true);
            break;
      
          default:
            // if (isPrintableCharacter(char)) {
            //   this.popupMenu.setFocusByFirstCharacter(this, char);
            // }
            break;
        }
      
        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    nameChangeGlobalElementObject.showValidationMessage  = function  (targetElement, attribute) {
      targetElement.parentNode.classList.add('wu-input__error');
      let targetElementId = targetElement.getAttribute("id");
      let errorEelementDiv = nameChangeFormSelection.querySelector("."+targetElementId+"-error");
      if(errorEelementDiv){
        errorEelementDiv.classList.remove("d-none");
      }
      if(attribute && errorEelementDiv) {
        errorEelementDiv.innerText = errorEelementDiv.getAttribute(attribute)
      }
    }
    nameChangeGlobalElementObject.hideValidationMessage  = function  (targetElement) {
      targetElement.parentNode.classList.remove('wu-input__error');
      let targetElementId = targetElement.getAttribute("id");
      let errorEelementDiv = nameChangeFormSelection.querySelector("."+targetElementId+"-error");
      if(errorEelementDiv){
        errorEelementDiv.classList.add("d-none");
      }
    }
    nameChangeGlobalElementObject.onKeyPressEventOfInputFields  = function  (event) {
      let elementId = event.currentTarget.id;
      let elementObject = document.getElementById(elementId);
      nameChangeGlobalElementObject.hideValidationMessage(elementObject);
    }
    nameChangeGlobalElementObject.onClickReasonForRequest  = function  (event) {
      let errorEelementDiv = nameChangeFormSelection.querySelector(".reasonForRequest-error");
      if(errorEelementDiv){
        errorEelementDiv.classList.add("d-none");
      }
    }
    nameChangeGlobalElementObject.validateinput = function (input,event){
      let elementId = event.currentTarget.id;
      let elementObject = document.getElementById(elementId);
      nameChangeGlobalElementObject.hideValidationMessage(elementObject);
      const value =input.value.trim();
       if(!(/^\d+$/.test(value))){
          nameChangeGlobalElementObject.showValidationMessage(elementObject, 'number-only-error-message')
        }else if(value?.length !== 10) {
          nameChangeGlobalElementObject.showValidationMessage(elementObject, 'min-max-error-message')
        }
        if(value.length===0){
          nameChangeGlobalElementObject.hideValidationMessage(elementObject);
        }
    }
    nameChangeGlobalElementObject.triggerValidation  = function  (event) {
      let tracking_numberEl =  nameChangeFormSelection.querySelector("#tracking_number");
      let first_nameEl =  nameChangeFormSelection.querySelector("#first_name");
      let middle_nameEl =  nameChangeFormSelection.querySelector("#middle_name");
      let mywu_goldcard_numberEl =  nameChangeFormSelection.querySelector("#mywu_goldcard_number");
      let last_nameEl =  nameChangeFormSelection.querySelector("#last_name");
      let emailAddressEl =  nameChangeFormSelection.querySelector("#emailAddress");
      let phoneNumberEl =  nameChangeFormSelection.querySelector("#phoneNumber");
      let receiverFirstNameEl =  nameChangeFormSelection.querySelector("#receiverFirstName");
      let receiverMiddleNameEl = nameChangeFormSelection.querySelector("#receiverMiddleName");
      let receiverLastNameEl =  nameChangeFormSelection.querySelector("#receiverLastName");
      let driverLicenceLabel =  nameChangeFormSelection.querySelector("#driverLicenceLabel");
      let stateNationalId =  nameChangeFormSelection.querySelector("#stateNationalId");
      let permanentResidenceCard =  nameChangeFormSelection.querySelector("#permanentResidenceCard");
      let passport =  nameChangeFormSelection.querySelector("#passport");
      let other =  nameChangeFormSelection.querySelector("#other");
      let updatedReceiverMiddleNameEl = nameChangeFormSelection.querySelector("#updatedReceiverMiddleName");
      let updatedReceiverFirstNameEl = nameChangeFormSelection.querySelector("#updatedReceiverFirstName");
      let updatedReceiverLastNameEl =  nameChangeFormSelection.querySelector("#updatedReceiverLastName");
      let humanKeyEL = nameChangeFormSelection.querySelector("#humanKey");
      let consentCheckBoxEl = nameChangeFormSelection.querySelector('input[name="consentCheckBox"]');
      let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      let isFormValid = true;
      let returnObject = {};

      returnObject['middle_name'] = middle_nameEl.value;
      returnObject['mywu_goldcard_number'] = mywu_goldcard_numberEl.value;
      returnObject['receiverMiddleName'] = receiverMiddleNameEl.value;
      returnObject['updatedReceiverMiddleName'] = updatedReceiverMiddleNameEl.value;
      returnObject['tracking_number'] = tracking_numberEl.value;
      returnObject['phoneNumber'] = phoneNumberEl.value;
      returnObject['stateNationalId'] = stateNationalId.value;
      returnObject['driverLicenceLabel'] = driverLicenceLabel.value;
      returnObject['permanentResidenceCard'] = permanentResidenceCard.value;
      returnObject['passport'] = passport.value;
      returnObject['other'] = other.value;
      if(humanKeyEL){
        nameChangeGlobalElementObject.hideValidationMessage(humanKeyEL);
        let capatchValue = humanKeyEL.value;
        returnObject['humanKey'] = capatchValue;
        if(capatchValue !== undefined  && capatchValue == ""){
          nameChangeGlobalElementObject.showValidationMessage(humanKeyEL);
          //isFormValid = false;
        }else{
          returnObject['humanKey'] = capatchValue;
        }
      }
      if(consentCheckBoxEl){
        nameChangeGlobalElementObject.hideValidationMessage(consentCheckBoxEl);
        let consentCheckBox = consentCheckBoxEl.checked;
        if(consentCheckBox !== undefined  && consentCheckBox != true){
          nameChangeGlobalElementObject.showValidationMessage(consentCheckBoxEl);
          isFormValid = false;
          consentCheckBoxEl.focus();
        }else{
          returnObject['consentCheckBox'] = consentCheckBox;
        }
      }
      if(updatedReceiverLastNameEl){
        nameChangeGlobalElementObject.hideValidationMessage(updatedReceiverLastNameEl);
        let updatedReceiverLastName = updatedReceiverLastNameEl.value;
        if(updatedReceiverLastName !== undefined  && updatedReceiverLastName == ""){
          nameChangeGlobalElementObject.showValidationMessage(updatedReceiverLastNameEl);
          isFormValid = false;
          updatedReceiverLastNameEl.focus();
        }else{
          returnObject['updatedReceiverLastName'] = updatedReceiverLastName;
        }
      }
      if(updatedReceiverFirstNameEl){
        nameChangeGlobalElementObject.hideValidationMessage(updatedReceiverFirstNameEl);
        let updatedReceiverFirstName = updatedReceiverFirstNameEl.value;
        if(updatedReceiverFirstName !== undefined  && updatedReceiverFirstName == ""){
          nameChangeGlobalElementObject.showValidationMessage(updatedReceiverFirstNameEl);
          isFormValid = false;
          updatedReceiverFirstNameEl.focus();
        }else{
          returnObject['updatedReceiverFirstName'] = updatedReceiverFirstName;
        }
      }
      if(receiverLastNameEl){
        nameChangeGlobalElementObject.hideValidationMessage(receiverLastNameEl);
        let receiverLastName = receiverLastNameEl.value;
        if(receiverLastName !== undefined  && receiverLastName == ""){
          nameChangeGlobalElementObject.showValidationMessage(receiverLastNameEl);
          isFormValid = false;
          receiverLastNameEl.focus();
        }else{
          returnObject['receiverLastName'] = receiverLastName;
        }
      }
      if(receiverFirstNameEl){
        nameChangeGlobalElementObject.hideValidationMessage(receiverFirstNameEl);
        let receiverFirstName = receiverFirstNameEl.value;
        if(receiverFirstName !== undefined  && receiverFirstName == ""){
          nameChangeGlobalElementObject.showValidationMessage(receiverFirstNameEl);
          isFormValid = false;
          receiverFirstNameEl.focus();
        }else{
          returnObject['receiverFirstName'] = receiverFirstName;
        }
      }
      if(emailAddressEl){
        nameChangeGlobalElementObject.hideValidationMessage(emailAddressEl);
        let emailAddress = emailAddressEl.value;
        if(emailAddress !== undefined){
          if(emailAddress == ""){
            nameChangeGlobalElementObject.showValidationMessage(emailAddressEl);
            isFormValid = false;
            emailAddressEl.focus();
          }else if(!emailAddress.match(mailformat)){
            nameChangeGlobalElementObject.showValidationMessage(emailAddressEl);
            isFormValid = false;
            emailAddressEl.focus();
          }else{
            returnObject['emailAddress'] = emailAddress;
          }
        }
      }
      if(last_nameEl){
        nameChangeGlobalElementObject.hideValidationMessage(last_nameEl);
        let last_name = last_nameEl.value;
        if(last_name !== undefined  && last_name == ""){
          nameChangeGlobalElementObject.showValidationMessage(last_nameEl);
          isFormValid = false;
          last_nameEl.focus();
        }else{
          returnObject['last_name'] = last_name;
        }
      }
      if(first_nameEl){
            nameChangeGlobalElementObject.hideValidationMessage(first_nameEl);
            let first_name = first_nameEl.value;
            if(first_name !== undefined  && first_name == ""){
            nameChangeGlobalElementObject.showValidationMessage(first_nameEl);
            isFormValid = false;
            first_nameEl.focus();
            }else{
            returnObject['first_name'] = first_name;
            }
        }
        if(tracking_numberEl){
          nameChangeGlobalElementObject.hideValidationMessage(tracking_numberEl);
          let tracking_number = tracking_numberEl.value;
          if(tracking_number !== undefined  && tracking_number == ""){
          nameChangeGlobalElementObject.showValidationMessage(tracking_numberEl);
          isFormValid = false;
          tracking_numberEl.focus();
          }
          else if(!(/^\d+$/.test(tracking_number))){
            nameChangeGlobalElementObject.showValidationMessage(elementObject, 'number-only-error-message')
          }else if(tracking_number?.length !== 10) {
            nameChangeGlobalElementObject.showValidationMessage(elementObject, 'min-max-error-message')
          }
          else{
          returnObject['tracking_number'] = tracking_number;
          }
      }
      console.log('Validation Event Triggered-- Status='+isFormValid);
      if(isFormValid == true){
        returnObject['status'] = "success";
      }else{
        returnObject['status'] = "error";
      }
      
      return returnObject;
    }
    nameChangeGlobalElementObject.verfiyCaptcha = function(recaptcha_response){
      document.getElementById("humanKey").value = recaptcha_response;
      console.log(recaptcha_response);
    }
    nameChangeGlobalElementObject.initateSubmitApi = async function(fromObject){
        nameChangeGlobalElementObject.triggerSubmitApi(fromObject);
    }
    nameChangeGlobalElementObject.showSpinner = function(){
      var showSpinnerBkgroundEl =  document.querySelector(".wu-spinner-overlay");
      var showSpinnerContainerEl =  document.querySelector(".wu-spinner");
      showSpinnerBkgroundEl.classList.remove('d-none');
      showSpinnerContainerEl.classList.remove('d-none');
    }
    nameChangeGlobalElementObject.hideSpinner = function(){
      var showSpinnerBkgroundEl =  document.querySelector(".wu-spinner-overlay");
      var showSpinnerContainerEl =  document.querySelector(".wu-spinner");
      showSpinnerBkgroundEl.classList.add('d-none');
      showSpinnerContainerEl.classList.add('d-none');
    }
    nameChangeGlobalElementObject.resetCaptcha = function(){
      var showSpinnerBkgroundEl =  nameChangeFormSelection.querySelector("#humanKey");
      showSpinnerBkgroundEl.value="";
      if(grecaptcha){
        grecaptcha.reset();
      }
    }
    nameChangeGlobalElementObject.triggerSubmitApi = async function(formObject){
      nameChangeGlobalElementObject.showSpinner();
      let serviceURl = "https://www3.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postNameChangeForm";
      if (window.location.hostname == 'www2.westernunion.com') {
          serviceURl =  "https://www2.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postNameChangeForm";
        }
      else if (window.location.hostname == 'www.westernunion.com') {
        serviceURl = "https://www.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postNameChangeForm";
      }  
      let tempObject = {};
      tempObject["consent"] =formObject["consentCheckBox"];
      tempObject["humanKey"] = formObject["humanKey"];
      tempObject["suppliedEmail"] =formObject["emailAddress"];
      tempObject["suppliedMTCN"] =formObject["tracking_number"];
      tempObject["suppliedSenderFirstName"] =formObject["first_name"];
      tempObject["suppliedSenderMiddleName"] =formObject["middle_name"];
      tempObject["suppliedSenderLastName"] =formObject["last_name"];
      tempObject["suppliedMyWU"] =formObject["mywu_goldcard_number"];
      tempObject["suppliedPhone"] =formObject["phoneNumber"];

      // we need to combined id and udpated receiver name as an ID value
      tempObject["driverLicenceLabel"] =formObject["driverLicenceLabel"];
      tempObject["stateNationalId"] =formObject["stateNationalId"];
      tempObject["passport"] =formObject["passport"];
      tempObject["permanentResidenceCard"] =formObject["permanentResidenceCard"];
      tempObject["other"] =formObject["other"];

   // we need to combined id and udpated receiver name as an ID value
      var supplied_comments ="";
      var idData = {
        id: []
      };
      let driver_icense = {
        "idType": "Driver License",
        "idValue": formObject["driverLicenceLabel"]
      }
      idData.id.push(driver_icense);
      let state_national_Id = {
        "idType": "State/National Id",
        "idValue": formObject["stateNationalId"]
      }
      idData.id.push(state_national_Id);
      let passport = {
        "idType": "Passport",
        "idValue": formObject["passport"]
      }
      idData.id.push(passport);
      let permanent_residence = {       
        "idType": "Permanent Residence",
        "idValue": formObject["permanentResidenceCard"]
      }
      idData.id.push(permanent_residence);
      let other = {
        "idType": "Other",
        "idValue": formObject["other"]
      }
      idData.id.push(other);
      let new_receiver_first_name = {
        "idType": "New Receiver First Name",
        "idValue": formObject["updatedReceiverFirstName"]
      }
      idData.id.push(new_receiver_first_name);
      let new_receiver_middle_name = {
        "idType": "New Receiver Middle Name",
        "idValue": formObject["updatedReceiverMiddleName"]
      }
      idData.id.push(new_receiver_middle_name);
      let new_receiver_last_name = {
        "idType": "New Receiver Last Name",
        "idValue": formObject["updatedReceiverLastName"]
      }
      idData.id.push(new_receiver_last_name);
      
      tempObject["suppliedReceiverFirstName"] =formObject["receiverFirstName"];
      tempObject["suppliedReceiverMiddleName"] =formObject["receiverMiddleName"];
      tempObject["suppliedReceiverLastName"] =formObject["receiverLastName"];
      tempObject["subject"] ="Name Change Form";
      tempObject["intakeChannel"] ="WU.com - Email/webform",
      tempObject["channelType"] ="Retail",
      tempObject["callerType"] ="Sender",
      tempObject["origin"] ="Digital Name Change Form",
      tempObject["ucdCountry"] ="United States",
      tempObject["country"] ="United States",
      tempObject["preferredLanguage"] ="English",
      tempObject = { ...idData, ...tempObject};
      for (let i = 0; i < idData.id.length; i++) {
        if (idData.id[i].idValue != ''){   
            supplied_comments = supplied_comments + idData.id[i].idType + ':' + idData.id[i].idValue+";";
        } 
      }
      tempObject["suppliedComments"] =supplied_comments;

      let requestPayload = tempObject;
      var xhr = new XMLHttpRequest();
      xhr.open("POST", serviceURl);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.onreadystatechange = function () {
        nameChangeGlobalElementObject.hideSpinner();
          if (xhr.readyState == 4 && xhr.status == 200) {
               console.log('success');
               nameChangeGlobalElementObject.showSubmitSuccessMessageFromApiResponse(xhr.responseText) 
          }
         
         console.log(xhr);
      };
      xhr.send(JSON.stringify(requestPayload));
    }
    nameChangeGlobalElementObject.showSubmitSuccessMessageFromApiResponse = function  (response) {
      console.log(response);
      var caseNumbeEl =  nameChangeFormSelection.querySelector(".nameChangeSubmitButton-error");
      let caseNumber = "";
      let parsedResponse = JSON.parse(response);
      if(parsedResponse && parsedResponse['compositeResponse'] && parsedResponse['compositeResponse'].length >1){
        let responseArray = parsedResponse['compositeResponse'];
        if(responseArray[1].httpStatusCode == 200 && responseArray[1].referenceId == "ref_case_query"){
          if(responseArray[1]['body'] && responseArray[1]['body']['CaseNumber']){
            caseNumber = responseArray[1]['body']['CaseNumber'];
            nameChangeGlobalElementObject.openMessageOverlay();
            var caseNumbeEl =  document.querySelector("#caseNumbeEl");
            if(caseNumbeEl){
              caseNumbeEl.innerText=caseNumber;
            }           
          }
        } else {
          nameChangeGlobalElementObject.resetCaptcha();
          caseNumbeEl.classList.remove('d-none');
          
        }
      }    
   }
    nameChangeGlobalElementObject.nameChangeFormCancelEventHandler = function  (event) {
      nameChangeGlobalElementObject.openWuHelpCenter();
    }
    nameChangeGlobalElementObject.nameChangeFormSubmitEventHandler  = function  (event) {
        console.log('Submit Event Triggered');
        let validatedFormObject = nameChangeGlobalElementObject.triggerValidation();
        if(validatedFormObject['status'] == "success"){
          nameChangeGlobalElementObject.initateSubmitApi(validatedFormObject);
        }
        console.log(validatedFormObject);
    }
    nameChangeGlobalElementObject.openMessageOverlay = function() {
      var overLayContainer = document.querySelector('.wu-overlay');
      overLayContainer.style.display ="flex";
    }
    nameChangeGlobalElementObject.openWuHelpCenter = function() {
      var win = window.open('https://wucare.westernunion.com/s/customer-care-home?language=en_US',"_self");
      win.focus()
    }
    const setButtonEventListeners  = function  (event) {
        var nameChangeCancelButtonElement =  nameChangeFormSelection.querySelector("#nameChangeCancelButton");
        var nameChangeSubmitButtonElement =  nameChangeFormSelection.querySelector("#nameChangeSubmitButton");
        nameChangeCancelButtonElement.addEventListener("click", function() { 
            nameChangeGlobalElementObject.nameChangeFormCancelEventHandler(event); 
        });
        nameChangeCancelButtonElement.addEventListener("input", ()=> { 
          document.getElementById();
        });
        nameChangeSubmitButtonElement.addEventListener("click", function() { 
            nameChangeGlobalElementObject.nameChangeFormSubmitEventHandler(event); 
        });
    }
    const loadnameChangeDefaultForm = () => {
        setButtonEventListeners();
    }
    if (/complete|interactive|loaded/.test(document.readyState)) {
        loadnameChangeDefaultForm();
    } else {
        window.addEventListener("load", loadnameChangeDefaultForm);
    }
}


